import { useMutation } from '@tanstack/react-query';

import { post } from '../../../redux/api';
import type { PackageLabelScope } from '../../../../shared/packageLabels';

export type BulkPackageLabelsRequest = {
  packageLocators: string[];
  labelId: number;
  scope: PackageLabelScope;
  scopeId?: string;
  shouldUseSpecificVersion?: boolean;
};

function bulkAssignPackageLabels({
  packageLocators,
  labelId,
  scope,
  scopeId,
  shouldUseSpecificVersion,
}: BulkPackageLabelsRequest) {
  return post(`/api/package-label-assignments/bulk`, {
    packageLocators,
    labelId,
    scope,
    scopeId,
    shouldUseSpecificVersion,
  });
}

/**
 * Hook that calls the bulk assign package labels endpoint.
 * @returns The mutation result.
 */
export function useBulkPackageLabels() {
  return useMutation({
    mutationFn: ({ packageLocators, labelId, scope, scopeId, shouldUseSpecificVersion }: BulkPackageLabelsRequest) =>
      bulkAssignPackageLabels({ packageLocators, labelId, scope, scopeId, shouldUseSpecificVersion }),
  });
}
